import { Component, Input, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from "primeng/config";

import { MemoPaymentView } from '@app/shared/views/MemoPaymentView';
import { ErrorView } from '@app/shared/models/ErrorView';

import { fadeIn } from 'assets/animations/animations';

@Component({
    selector: 'app-payment-periodic-form',
    templateUrl: './payment-periodic-form.component.html',
    styleUrls: ['./payment-periodic-form.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class PaymentPeriodicFormComponent implements OnInit {

  dayMonthTouched: boolean;
  dayWeekTouched: boolean;
  firstDayWeek: number;

  @Input() endTaskDateNotHigherThanStartDate: boolean;
  @Input() endTaskDateNotHigherThanToday: boolean;
  @Input() payment: MemoPaymentView;
  @Input() isNewPayment: boolean;
  @Input() isTaskEditable: boolean;
  @Input() paymentSavedOk: boolean;
  @Input() endTaskDateError: ErrorView = new ErrorView("","","");

  @Output() setEndTaskDateNotHigherThanStartDateMethod = new EventEmitter();
  @Output() setEndTaskDateNotHigherThanTodayMethod     = new EventEmitter();

  @ViewChild('paymentPeriodicForm') paymentPeriodicForm: NgForm;

  constructor(
    private translate: TranslateService,
    private primeConfig: PrimeNG
  ){
    this.translate.get('primeng').subscribe(res => this.primeConfig.setTranslation(res));
  }

  ngOnInit(): void {
    this.firstDayWeek = this.translate.currentLang == 'en-US' ? 0 : 1;
    if (this.payment.startTaskDate != null) {
      this.payment.startTaskDate = new Date(this.payment.startTaskDate.toString());
    }
    if (this.payment.endTaskDate != null) {
      this.payment.endTaskDate = new Date(this.payment.endTaskDate.toString());
    }
  }

  public setStartTaskDate(value: Date):void {
    this.payment.startTaskDate = value;
    this.setEndTaskDateNotHigherThanStartDateMethod.emit();
  }

  public setEndTaskDate(value: Date):void{
    this.payment.endTaskDate =  new Date(value.toString());

    this.setEndTaskDateNotHigherThanTodayMethod.emit();
  }
}
